import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const StickyElement = ({
  children,
  bottomPos = false,
  topOffset = 0,
  bottomOffset = 0,
  elementIdToObserve
}) => {
  const wrapperRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  const [isIphone, setIsIphone] = useState(false);

  useEffect(() => {
    setIsIphone(/iPhone/.test(navigator.userAgent) && !window.MSStream);
  }, []);
  // it fixes extra padding in iPhone safari
  const additionalBottomSpace = isIphone ? 60 : 0;

  useEffect(() => {
    const wrapperEl = wrapperRef.current;
    const windowHeight = window.innerHeight;
    const elementToObserve =
      document.getElementById(elementIdToObserve) || document.body;
    let isTimeToSet;

    const checkPosition = () => {
      const wrapperElBounds = wrapperEl?.getBoundingClientRect();

      if (!bottomPos) {
        isTimeToSet = wrapperElBounds?.y - topOffset < 1;
      } else {
        isTimeToSet =
          wrapperElBounds?.y + wrapperElBounds?.height >
          windowHeight + additionalBottomSpace + bottomOffset;
      }

      setIsSticky(isTimeToSet);
    };

    checkPosition();

    if (elementToObserve && window.ResizeObserver) {
      const { ResizeObserver } = window; // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver/observe
      const observer = new ResizeObserver(() => {
        checkPosition();
      });
      observer.observe(elementToObserve);
    }

    window.addEventListener('scroll', checkPosition);
    window.addEventListener('resize', checkPosition);
    return () => {
      window.removeEventListener('scroll', checkPosition);
      window.removeEventListener('resize', checkPosition);
    };
  }, []);

  return typeof children === 'function'
    ? children(isSticky, wrapperRef)
    : children;
};

StickyElement.displayName = 'StickyElement';

StickyElement.propTypes = {
  children: PropTypes.func,
  bottomPos: PropTypes.bool,
  topOffset: PropTypes.number,
  bottomOffset: PropTypes.number,
  isResizeObserver: PropTypes.bool,
  elementIdToObserve: PropTypes.string
};

export default StickyElement;
